import { render, staticRenderFns } from "./ExtratoAssociadoList.vue?vue&type=template&id=a7d4d5fc"
import script from "./ExtratoAssociadoList.vue?vue&type=script&lang=js"
export * from "./ExtratoAssociadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports